<template>
  <a-layout>
    <a-layout-content :style="{ margin: '24px 16px ', overflow: 'initial' }">
      <a-card :bordered="false" :bodyStyle="{ padding: '16px 0', height: '100%' }" :style="{ height: '100%' }">
        <div class="account-settings-info-main">
          <div class="account-settings-info-left">
            <a-menu mode="inline"
                    :style="{ border: '0', width: 'auto'}"
                    :selectedKeys="selectedKeys"
                    @click="jump"
                    type="inner">
              <a-menu-item key="/admin_setting/base">
                基本设置
              </a-menu-item>
              <a-menu-item key="/admin_setting/password">
                修改密码
              </a-menu-item>
<!--              <a-menu-item key="/admin_setting/addAdmin">-->
<!--                添加用户-->
<!--              </a-menu-item>-->
            </a-menu>
          </div>
          <!-- 路由加载位置 -->
          <router-view/>
        </div>
      </a-card>
    </a-layout-content>
  </a-layout>
</template>

<script>
  export default {
    name: 'Setting',
    data () {
      return {
        userInfo: {},
        selectedKeys: ['/admin_setting/base'],
      }
    },
    created () {
      this.selectedKeys[0] = this.$route.path
    },
    methods: {
      jump (path) {
        this.selectedKeys[0] = path.key
        this.$router.push({ path: path.key, replace: true })

      },
    },
  }
</script>

<style lang="less">
  .account-settings-info-main {
    display: flex;
    overflow: auto;
    width: 100%;
    height: 100%;

    .account-settings-info-left {
      border-right: 1px solid #e8e8e8;
      width: 224px;
    }

    .account-settings-info-right {
      flex: 1 1;
      padding: 8px 40px;

      .account-settings-info-title {
        color: rgba(0, 0, 0, .85);
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 12px;
      }

      .account-settings-info-view {
        padding-top: 12px;
      }
    }
  }

</style>